/**
 * The line under a guest upload control (legal-pages ticket 04; wording A-1 in
 * `.scratch/legal-pages/drafts/in-product-notices.md`, held in `lib/notices`).
 *
 * Unpublished, it is one sentence that is true without the legal pages: the
 * résumé can be processed by AI providers or custom models. Once
 * `legal.published`, "By uploading, you agree to our Terms and Privacy Policy"
 * replaces it (owner, 2026-10-15; the AI-providers fact is in the Privacy Policy,
 * section 4), naming each document that has a page; the links open in a new tab
 * so a chosen file is not lost. It was three sentences until 2026-10-06, when the owner cut it
 * for length: that employers are not sent the résumé and that a guest's upload
 * is deleted after 7 days are now said in the Privacy Policy only (5.2, 7).
 *
 * It fills the `uploadNotice` slot the landing hero and `/start` both have in
 * their prototypes. On `/start` it sits inside the upload control's `<label>`
 * (a link in a label opens its page and does not open the file chooser); the
 * landing hero sets it below the box, in 11px fine print.
 */
import React from 'react';
import { legal } from '../lib/legal';
import { UPLOAD_AGREE_LEAD, UPLOAD_NOTICE } from '../lib/notices';
import { AgreementDocLinks, agreementDocuments } from './AgreementBox';
import './LegalNotices.css';

export function UploadNotice() {
  const agrees = legal.published && agreementDocuments().length > 0;
  return (
    <span className="cj-legal-inline" data-upload-notice="">
      {agrees ? <>{UPLOAD_AGREE_LEAD} <AgreementDocLinks names="short" /></> : UPLOAD_NOTICE}
    </span>
  );
}
